module.exports = __webpack_public_path__ + "static/media/banner.823d0beb.svg";